import api from "./axios";

// Client/business notes — reachable by admins and permitted employees. Edit/
// delete is allowed for admins (any note) and employees (their own only); the
// backend enforces this.
export const listBusinessNotes = (businessId, params = {}) =>
  api.get(`/businesses/${businessId}/notes`, { params });
export const createBusinessNote = (businessId, payload) =>
  api.post(`/businesses/${businessId}/notes`, payload);
export const updateBusinessNote = (noteId, payload) =>
  api.put(`/business-notes/${noteId}`, payload);
export const deleteBusinessNote = (noteId) => api.delete(`/business-notes/${noteId}`);
